import { Layout, Text } from '@loadsmart/miranda-react'

import { type StopInfo } from '../../../domain/StopInfo'

export type StopInformationProps = {
  disabled: boolean
  stop: StopInfo
}

export function StopInformation({ stop, disabled }: StopInformationProps) {
  const textColor = disabled ? 'color-neutral-90' : 'color-neutral-100'

  return (
    <Layout.Stack gap="spacing-0-5" align="flex-start">
      <Text variant="body-md-bold" color={textColor}>
        {stop.stopTitle}
      </Text>
      <Text variant="body-sm" color={textColor}>
        {stop.stopSubtitle}
      </Text>
    </Layout.Stack>
  )
}
